var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1157_9316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 36C27.9412 36 36.0001 27.9411 36.0001 18C36.0001 8.05887 27.9412 0 18.0001 0C8.0589 0 0 8.05887 0 18C0 27.9411 8.0589 36 18.0001 36Z",
    fill: "url(#paint0_linear_1157_9316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9801 9.38827C27.6977 9.10828 28.4395 9.73618 28.2819 10.4901L25.0637 25.8731C24.9134 26.5943 24.0661 26.9191 23.4722 26.4828L18.614 22.9167L16.1377 25.4453C15.7025 25.8889 14.9522 25.7083 14.7655 25.1168L12.9789 19.4452L8.18971 18.0307C7.56063 17.8452 7.52428 16.9701 8.13396 16.7313L26.9801 9.38827ZM24.6177 12.8016C24.8273 12.6161 24.5837 12.2889 24.3461 12.4367L14.0091 18.8476C13.8272 18.9603 13.7436 19.1822 13.8078 19.387L15.2175 25.5773C15.2455 25.6719 15.3812 25.6585 15.3933 25.5604L15.7085 20.8428C15.7206 20.7264 15.7763 20.6198 15.8636 20.5422L24.6177 12.8016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3462 12.4367C24.5838 12.2888 24.8274 12.6161 24.6177 12.8016L15.8638 20.5422C15.7765 20.6197 15.7208 20.7264 15.7086 20.8428L15.3935 25.5603C15.3814 25.6585 15.2456 25.6718 15.2177 25.5773L13.808 19.387C13.7437 19.1821 13.8274 18.9603 14.0092 18.8476L24.3462 12.4367Z",
    fill: "#9EC2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2685 25.6415C15.0406 25.5603 14.8479 25.3785 14.7655 25.1166L12.9789 19.4451L8.18971 18.0305C7.56063 17.845 7.52428 16.9699 8.13396 16.7311L26.98 9.3882C27.443 9.20757 27.917 9.40514 28.1509 9.77126C28.1073 9.7046 28.0552 9.6428 27.997 9.58824L15.2115 20.0258V20.4827L15.1412 20.4318L15.2115 23.3094V25.6173C15.2297 25.6258 15.249 25.6331 15.2684 25.6391V25.6415H15.2685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.614 22.9163L16.1377 25.4448C16.1171 25.4654 16.0953 25.486 16.0734 25.5042C16.0516 25.5224 16.0298 25.5382 16.0068 25.5539C16.0056 25.5551 16.0056 25.5551 16.0056 25.5551C15.9595 25.5854 15.9123 25.6109 15.8626 25.6315C15.8371 25.6412 15.8128 25.6509 15.7874 25.6569C15.6819 25.6884 15.5741 25.6969 15.4674 25.686C15.4396 25.6836 15.4116 25.6788 15.385 25.6739C15.3813 25.6739 15.3777 25.6727 15.3741 25.6716C15.3474 25.6643 15.3207 25.657 15.2941 25.6485C15.2856 25.6461 15.2771 25.6436 15.2686 25.6388L15.2117 23.3091V20.4824L18.614 22.9163Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0745 25.5039C16.0523 25.5224 16.0301 25.5396 16.0067 25.5557V25.5544C16.0302 25.5384 16.0523 25.5224 16.0745 25.5039Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0073 25.5537V25.5555C16.0073 25.5555 16.0073 25.5537 16.0055 25.5555C16.0055 25.5555 16.0055 25.5555 16.0073 25.5537Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8622 25.6313C15.9121 25.6106 15.9595 25.5851 16.0057 25.5547C15.9595 25.585 15.9108 25.6106 15.8622 25.6313Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.467 25.6865C15.5737 25.6978 15.6816 25.6889 15.787 25.6562C15.7107 25.6814 15.6319 25.6927 15.5531 25.6927C15.5288 25.6927 15.5046 25.6915 15.4816 25.6889C15.4767 25.689 15.4719 25.689 15.467 25.6865Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4681 25.6864C15.473 25.6889 15.4779 25.6889 15.4828 25.6889C15.4571 25.6876 15.4339 25.6838 15.4095 25.6787C15.429 25.6826 15.4486 25.6851 15.4681 25.6864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4681 25.6865C15.4486 25.6852 15.429 25.6827 15.4096 25.6789C15.401 25.6777 15.3925 25.6764 15.3851 25.6738C15.412 25.6789 15.44 25.684 15.4681 25.6865Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2937 25.6484C15.3205 25.6573 15.3475 25.6649 15.3743 25.6725C15.3633 25.67 15.3523 25.6675 15.3414 25.665C15.3365 25.6637 15.3316 25.6625 15.3279 25.6599C15.3169 25.6573 15.3047 25.6535 15.2937 25.6484Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3408 25.6641C15.3522 25.6666 15.3636 25.6691 15.375 25.6716C15.3636 25.6704 15.3522 25.6679 15.3408 25.6641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2942 25.649C15.3054 25.6541 15.3179 25.658 15.3291 25.6605C15.3104 25.6566 15.2918 25.6502 15.2731 25.6426C15.2805 25.6451 15.2867 25.6477 15.2942 25.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2963 25.6493C15.2883 25.648 15.2816 25.6452 15.2736 25.6426C15.2723 25.6439 15.2696 25.6426 15.2683 25.6413V25.6387C15.2776 25.6439 15.2869 25.6466 15.2963 25.6493Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2115 23.3096L15.269 25.6392C15.2494 25.6332 15.2299 25.6259 15.2115 25.6174V23.3096Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2116 20.4825V23.3093L15.1406 20.4316L15.2116 20.4825Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6177 12.8015L15.8638 20.5421C15.7765 20.6197 15.7208 20.7264 15.7086 20.8427L15.394 25.5607C15.3819 25.6589 15.2462 25.6722 15.217 25.5776L13.808 19.387C13.7437 19.1822 13.8274 18.9603 14.0092 18.8476L24.3462 12.4367C24.5838 12.2888 24.8275 12.6161 24.6177 12.8015Z",
    fill: "#ADBCC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1157_9316",
    x1: 18.0001,
    y1: 0,
    x2: 18.0001,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1157_9316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.0001,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTelegram);
export default __webpack_public_path__ + "static/media/share-telegram.9e1df80b0c265956b9171cd0b61d126d.svg";
export { ForwardRef as ReactComponent };